import React, { useState } from "react";

const Navdata = () => {

  const [iscurrentState, setIscurrentState] =
    useState("Dashboard");

  const closeMobileSidebar = () => {
    document.body.classList.remove(
      "vertical-sidebar-enable"
    );
  };

  const handleNavigation = (state) => {
    setIscurrentState(state);
    closeMobileSidebar();
  };

  const menuItems = [

    // ==========================================
    // MENU HEADER
    // ==========================================

    {
      label: "Menu",
      isHeader: true,
    },


    // ==========================================
    // DASHBOARD
    // ==========================================

    {
      id: "dashboard",

      label: "Dashboard",

      icon: "ri-dashboard-2-line",

      link: "/dashboard",

      click: function () {
        handleNavigation("Dashboard");
      },

      stateVariables:
        iscurrentState === "Dashboard",
    },


    // ==========================================
    // LEADS
    // ==========================================

    {
      id: "leads",

      label: "Leads",

      icon: "ri-user-follow-line",

      link: "/leads",

      click: function () {
        handleNavigation("Leads");
      },

      stateVariables:
        iscurrentState === "Leads",
    },


    // ==========================================
    // CONTACTS
    // ==========================================

    {
      id: "contacts",

      label: "Contacts",

      icon: "ri-contacts-line",

      link: "/contacts",

      click: function () {
        handleNavigation("Contacts");
      },

      stateVariables:
        iscurrentState === "Contacts",
    },


    // ==========================================
    // OPPORTUNITIES
    // ==========================================

    {
      id: "opportunities",

      label: "Opportunities",

      icon: "ri-hand-coin-line",

      link: "/portal/opportunities",

      click: function () {
        handleNavigation("Opportunities");
      },

      stateVariables:
        iscurrentState === "Opportunities",
    },


    // ==========================================
    // ORGANIZATIONS
    // ==========================================

    {
      id: "organizations",

      label: "Organizations",

      icon: "ri-building-line",

      link: "/portal/organizations",

      click: function () {
        handleNavigation("Organizations");
      },

      stateVariables:
        iscurrentState === "Organizations",
    },


    // ==========================================
    // TICKETS
    // ==========================================

    {
      id: "tickets",

      label: "Tickets",

      icon: "ri-customer-service-2-line",

      link: "/portal/tickets",

      click: function () {
        handleNavigation("Tickets");
      },

      stateVariables:
        iscurrentState === "Tickets",
    },


    // ==========================================
    // CALENDAR
    // ==========================================

    {
      id: "calendar",

      label: "Calendar",

      icon: "ri-calendar-line",

      link: "/portal/calendar",

      click: function () {
        handleNavigation("Calendar");
      },

      stateVariables:
        iscurrentState === "Calendar",
    },


    // ==========================================
    // DOCUMENTS
    // ==========================================

    {
      id: "documents",

      label: "Documents",

      icon: "ri-file-text-line",

      link: "/portal/documents",

      click: function () {
        handleNavigation("Documents");
      },

      stateVariables:
        iscurrentState === "Documents",
    },

  ];

  return (
    <React.Fragment>
      {menuItems}
    </React.Fragment>
  );
};

export default Navdata;